<template>
  <v-app>
    <snackbar ref="snackbar"/>
    <confirm-dialog ref="confirmDialog"/>
    <router-view id="view"/>
  </v-app>
</template>

<script>
import Vue from 'vue'
import AlertChip from '@/components/base/AlertChip'
import IconLabel from '@/components/base/IconLabel'
import TextField from '@/components/base/TextField'
import Combobox from '@/components/base/Combobox'
import Autocomplete from '@/components/base/Autocomplete'

import Snackbar from '@/components/base/Snackbar'
import ConfirmDialog from '@/components/base/ConfirmDialog'

Vue.component('alert-chip', AlertChip)
Vue.component('icon-label', IconLabel)
Vue.component('text-field', TextField)
Vue.component('combobox', Combobox)
Vue.component('autocomplete', Autocomplete)

export default {
    name: 'App',
    components: { Snackbar, ConfirmDialog },
    mounted () {
        Vue.prototype.$snackbar = this.$refs.snackbar
        Vue.prototype.$confirmDialog = this.$refs.confirmDialog
    }
}
</script>
